const dateOptions: Intl.DateTimeFormatOptions = {
    //   day: "2-digit",
    //   month: "short",
    //   year: "numeric",
    dateStyle: "long",
  };
  
  export const formatDate = (date: string) => {
    return new Date(`${date}T00:00:00+03:00`).toLocaleDateString(
      "ar",
      dateOptions
    );
  };
  